import { z } from "zod/v4";
import { Form, FormProps } from "@/components/form";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import useFetch from "@/hooks/use-fetch";
import { checkBarrio } from "../api/check-barrio";
import { getAllCiudades } from "../../ciudades/api/get-all-ciudades";
import { getCiudad } from "../../ciudades/api/get-ciudad";

export const addBarrioFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    codigo: z.string().nonempty("Este campo es requerido"),
    ciudadId: z.string().nonempty("Este campo es requerido"),
});

export default function AddBarrioForm({
    form,
    ...props
}: FormProps<z.input<typeof addBarrioFormSchema>>) {
    const { fetch, value, loading } = useFetch(async (codigo: string) => {
        if (codigo) return await checkBarrio(codigo);
        return undefined;
    }, { debounceMs: 500 });

    const barrioExists = value !== null && value !== undefined;

    return <Form form={form} gap={3} {...props}>
        <Collapse in={barrioExists} sx={{ marginY: "-10px" }}>
            <Alert severity={"warning"}>
                Ya existe un barrio con ese código. No se pueden repetir códigos de barrio.
            </Alert>
        </Collapse>

        <Form.TextField name="nombre" label="Nombre" />
        <Form.TextField name="codigo" label="Código" onChange={e => fetch(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.ModelComboBoxAsync
            name="ciudadId"
            label="Ciudad"
            get={getCiudad}
            getAll={getAllCiudades}
        />
        <Form.SubmitButton disabled={barrioExists}>Guardar</Form.SubmitButton>
    </Form>;
}
    